<template>
    <Paper class="barCodeRule" v-if="!searchIndex">
        <el-row type="flex" class="barCodeRule-search row-bg" justify="space-between">
            <el-col :span="22">
                <el-row>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['ruleCode']" placeholder="规则代码"></el-input>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['ruleName']" placeholder="规则名称"></el-input>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-input v-model="searchData['codeNum']" placeholder="条码位数"></el-input>
                    </el-col>
                    <el-col class="sn-search-item">
                        <el-select v-model="searchData['status']" placeholder="状态">
                            <el-option v-for="item in recStatusList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-col>
                    <div class="search-margin">
                        <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                            {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                        </el-button>
                    </div>
                </el-row>
            </el-col>
            <el-col class="barCodeRule-search-right" :span="2">
                <el-button class="barCodeRule-add" type="primary" size="mini" @click="newGroup" icon="el-icon-plus">{{$translate('lang.E3202102260005', { defaultText: '新 增' })}}</el-button>
                <img class="barCodeRule-update" src="../../../assets/images/updataButton.svg" width="30" height="28" alt="同步">
            </el-col>
        </el-row>
        <MTable :config="config" :pageTotal="pageTotal" :tableData="tableData" @rowDBclick="rowDBclick" @pageChange="pageChange" @sizeChange="sizeChange">
        </MTable>
    </Paper>
    <div v-else>
        <DetailPage :type="type" :apiList="apiList" :inFoList="inFoList" :formData="formData" :inFoTable="inFoTable" :tableConfig="tableConfig" :amendState="amendState" :saveItemValid="saveItemValid"
            :verification="verification" @saveSuccess="saveSuccess" @returnList="returnList"></DetailPage>
    </div>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import MTable from '../../../components/IdentityComponent/Main';
import DetailPage from '../CommodityComponents/DetailPage';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import { config, inFoList, inFoTable, tableConfig } from './config';
import { getBarCodeRule, saveBarCodeRule, saveBarCodeRuleDetail, getBarCodeRuleDetail, deleteBarCodeRuleDetail } from '../../../api/Commodity';
export default {
    name: 'barCodeRule',
    components: { Paper, MTable, DetailPage },
    data() {
        return {
            config: config,
            inFoList: inFoList,
            inFoTable: inFoTable,
            tableConfig: tableConfig,
            formData: {},
            searchData: {},
            searchLoading: false,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            verification: {
                ruleCode: [{ required: true, message: '规则代码不能为空', trigger: 'blur' }],
                ruleName: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
                codeNum: [{ required: true, message: '条码位数不能为空', trigger: 'change' },
                    { type: 'number', message: '条码位数请输入数字', trigger: 'blur' }],
                status: [{ required: true, message: '状态不能为空', trigger: 'blur' }]
            },
            amendState: false,
            searchIndex: false,
            recStatusList: [],
            recStatusObj: {},
            apiList: {
                saveApi: saveBarCodeRule,
                saveDetailApi: saveBarCodeRuleDetail,
                getDetailApi: getBarCodeRuleDetail,
                deleteDetailApi: deleteBarCodeRuleDetail
            },
            type: 'BarCodeRuleGroup'
        };
    },
    methods: {
        searchChange() {
            this.pageNo = 1;
            this.loadData();
        },
        restSearchChange() {
            this.searchData = this.$options.data.call(this).searchData;
        },
        newGroup() {
            this.amendState = false;
            this.formData = {};
            this.searchIndex = true;
        },
        loadData() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchData
            };
            this.searchLoading = true;
            getBarCodeRule(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(item => {
                        item.recStatusName = this.recStatusObj[item.status];
                    });
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            // this.getDetailTable();
            this.loadData();
        },
        returnList() {
            this.searchIndex = false;
            this.loadData();
        },
        async dictData() {
            const option = await dictWithUrl('REC_STATUS');
            const dictOptions = {};
            if (option && +option.code === 0) {
                this.recStatusList = option.data.REC_STATUS;
                option.data.REC_STATUS.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
                this.recStatusObj = dictOptions;
            }
        },
        rowDBclick(row) {
            this.amendState = true;
            row.codeNum = +row.codeNum;
            this.formData = Object.assign({}, row);
            this.searchIndex = true;
        },
        saveSuccess() {
            this.amendState = true;
        },
        saveItemValid(row, form) {
            let validFlag = true;
            if (+row.paraNum > +row.paraNumTo) {
                this.$message.warning('段位数到不能小于段位数从');
                validFlag = false;
                return validFlag;
            }
            if (+row.paraNumTo > +form.codeNum) {
                this.$message.warning('段位数到不能大于条码位数');
                validFlag = false;
            }
            return validFlag;
        }
    },
    async mounted() {
        await this.dictData();
        this.loadData();
    }
};
</script>
<style lang="less">
.barCodeRule {
    .sn-search-item {
        width: 180px;
    }
    .barCodeRule-search {
        margin-bottom: 20px;
    }
    .barCodeRule-search-right {
        display: flex;
        justify-content: end;
        align-items: center;
    }
    .barCodeRule-add {
        margin-right: 10px;
    }
    .barCodeRule-update {
        cursor: pointer;
    }
}
</style>